export const blockIconsBusinessandpaymentsSavingsNew = (
	<span className='material-symbols-outlined'>savings</span>
);
